<template>
  <div class="relative flex">
    <div v-if="selectedIndex > 0" class="flex justify-start items-center absolute z1 pb1" style="top: 0; bottom: 0; left: -35px">
      <button class="btn btn-carousel p0" @click="navigation(selectedIndex - 1)">
        <i class="h1 icon icon-angle-left-icon bold"></i>
      </button>
    </div>

    <div id="carousel" class="flex relative thin-scroll pb1">
      <div
        v-for="(billet, index) in billets"
        :id="`billet-${index}`"
        :key="billet.uuid"
        class="mx-small p2 flex flex-column justify-center white-bg nowrap pointer"
        :class="index === selectedIndex ? 'border-blue':'unselected'"
        @click="navigation(index)"
      >
        <h5 class="col-12 h5n m0">{{ billet.product_name }} - {{ billet.customer.firstname }} {{ billet.customer.lastname }} </h5>
        <h5 v-if="!billet.unlimited_usage && billet.remainingQuantity" class="col-12 h6n m0">
          {{ billet.remainingQuantity }}
          <span v-if="billet.remainingQuantity == 1"> session restante</span>
          <span v-else> sessions restantes</span>
        </h5>
      </div>
    </div>

    <div v-if="selectedIndex < billets.length -1" class="flex justify-end items-center absolute z1 pb1" style="top: 0; bottom: 0; right: -35px">
      <button class="btn btn-carousel p0" @click="navigation(selectedIndex + 1)">
        <i class="h1 icon icon-angle-right-icon bold"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  components: {},
  props: {
    billets: {
      type: Array,
      default: () => []
    },
    change: {
      type: Function,
      default: () => {}
    }
  },
  setup (props) {
    const store = useStore();
    const selectedIndex = inject('selectedIndex');
    const router = useRouter();
    const route = useRoute();
    const activities = computed(() => store.state.activities || []);

    const moveToElement = index => {
      if (index !== null) {
        const el = document.getElementById(`billet-${index}`);
        const carouselEl = document.getElementById('carousel');
        carouselEl.style.scrollSnapType = 'none';
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        setTimeout(() => { carouselEl.style.scrollSnapType = 'x mandatory'; }, 1000);
      }
    };

    const navigation = index => {
      if (index !== selectedIndex.value) {
        store.commit('setSelected', []);
        store.commit('setSession', null);
        store.commit('setSelectedActivity', []);
        store.commit('setSelectedActivityKey', null);
        selectedIndex.value = index;
        props.change(index);
        moveToElement(selectedIndex.value);
      } else if (activities.value.length > 1) {
        router.push({ name: 'ActivitiesList', params: { billet_uuid: route.params.billet_uuid } });
      } else {
        router.push({ name: 'GroupSessionsPlanner', params: { billet_uuid: route.params.billet_uuid } });
      }
    };

    onMounted(() => {
      moveToElement(selectedIndex.value);
    });

    return { navigation, selectedIndex };
  }
};
</script>

<style lang="scss" scoped>
.border-blue{
  border: 1px solid #00a6c6;
  color: #00a6c6;
}

.no-border-top{
  border-top: 0;
}

.unselected{
  opacity: .5;
  border: 1px solid black
}

.btn-carousel {
  padding:3px;
  background-color: transparent;
  border: 0;
  color: #bbb;
  font-family: DINWeb, sans-serif;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.3s ease-in all;
  cursor: pointer;
}
.btn-carousel:hover {
  color: #333;
}
</style>
